export const header = {
  logo: '/assets/images/logos/site-logo.svg',
  book_button: 'Book A Service',
  navigation: [
    {
      title: 'Home',
      link: '/',
    },
    {
      title: 'About',
      submenu: [
        {
          title: 'About Company',
          link: '/about',
        },
        {
          title: 'Services',
          link: '/services',
        },
        {
          title: 'Blog',
          link: '/blog',
        },
      ],
    },
    {
      title: 'Flooring services',
      submenu: [
        {
          title: 'Subfloor Preparation',
          link: '/services/subfloor-preparation',
        },
        {
          title: 'Flooring Installation',
          submenu: [
            {
              title: 'Engineered Wood Flooring',
              link: '/services/engineered-wood-flooring',
            },
            {
              title: 'Solid Wood Flooring',
              link: '/services/solid-wood-flooring',
            },
            {
              title: 'Laminate Flooring',
              link: '/services/laminate-flooring',
            },
            {
              title: 'Vinyl Flooring',
              link: '/services/vinyl-flooring',
            },
          ],
        },
        {
          title: 'Hardwood Floor Refinishing',
          link: '/services/hardwood-floor-refinishing',
        },
        {
          title: 'Soundproof Flooring',
          link: '/services/soundproof-flooring',
        },
        {
          title: 'Floor Demolition',
          link: '/services/floor-demolition',
        },
      ],
    },
    {
      title: 'Stairs services',
      submenu: [
        {
          title: 'Handrail Installation',
          link: '/services/handrail-installation',
        },
        {
          title: 'Handrail Refinishing',
          link: '/services/handrail-refinishing',
        },
        {
          title: 'Stairs Installation',
          link: '/services/stairs-installation',
        },
        {
          title: 'Custom Staircase Installation',
          link: '/services/custom-staircase-installation',
        },
      ],
    },
    {
      title: 'FAQ',
      link: '/faq',
    },
    {
      title: 'Contact',
      link: '/contact',
    },
  ],
};
